<template>
  <div
    class="p-4 flex flex-col gap-y-4 justify-center items-start border border-gray-200 dark:border-gray-500 bg-white dark:bg-slate-700 rounded-xl relative"
  >
    <div
      :class="hasSchema ? 'bg-teal-500' : 'bg-white'"
      class="absolute top-3 start-3 p-0.5 px-1 flex items-center gap-x-2 rounded border border-teal-500"
    >
      <span class="text-black text-[8px] font-mono"> service id: {{ serviceId || 'null' }} </span>
      <div v-if="hasSchema" class="p-0.5 rounded-full animate-ping bg-white"></div>
    </div>

    <div class="flex justify-between items-start w-full">
      <div
        class="aspect-square w-20 h-20 flex justify-center items-center rounded-xl bg-primary/10"
      >
        <slot name="icon">
          <faFileLines class="w-8 fill-primary" />
        </slot>
      </div>
      <div class="flex items-center gap-x-3">
        <RouterLink
          :to="{ name: 'ShareServiceCardView', params: { serviceId } }"
          v-if="canShare"
          class="hover:scale-105"
        >
          <faShareNodes class="w-4 fill-primary" />
        </RouterLink>
        <slot name="serviceCard">
          <RouterLink
            v-if="serviceId"
            :to="{
              name: 'ServiceCardView',
              params: {
                category,
                serviceId
              }
            }"
            class="text-xs flex-1 flex items-center gap-x-2 rounded-full px-3 py-1.5 border border-primary text-primary font-semibold hover:scale-105"
          >
            <i class="ica-custom-fonts-dashed-list"></i>
            {{ $t('serviceCard') }}
          </RouterLink>
        </slot>
      </div>
    </div>
    <div class="w-full flex-1 flex flex-col gap-y-0.5">
      <span class="text-start text-xs">
        {{ label }}
      </span>
      <slot name="subtitle"></slot>
    </div>

    <!-- <div class="w-full flex justify-between gap-x-3 text-xs text-white font-bold">
      <slot name="applicationTracking">
        <router-link
          v-if="serviceId"
          :to="`/application-tracking`"
          class="flex-1 rounded-xl px-1 py-2 bg-primary text-center hover:scale-105 active:scale-100"
        >
          {{ $t('applicationTrackingMenu') }}
        </router-link>
      </slot>
    </div> -->
    <slot name="footer">
      <div class="w-full flex justify-between gap-x-3 text-xs text-white font-bold">
        <slot name="start-service"> </slot>
        <slot name="applicationTracking">
          <router-link
            v-if="serviceId"
            :to="`/application-tracking`"
            class="w-fit ps-2 pe-1 rounded-md bg-primary/80 hover:bg-primary flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed font-normal"
          >
            <span class="ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
              {{ $t('applicationTrackingMenu') }}
            </span>
          </router-link>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import faFileLines from '@/assets/icons/faFileLines.svg?component'
import faShareNodes from '@/assets/icons/faShareNodes.svg?component'
import { usePublicServicesStore } from '@/stores/public_services'

const props = defineProps({
  label: String,
  serviceId: Number,
  serviceSlug: String,
  category: String,
  canShare: {
    type: Boolean,
    default: () => true
  }
})

const publicServiceStore = usePublicServicesStore()

const hasSchema = computed(() => {
  return publicServiceStore.availableSchemas.includes(props.serviceId || props.serviceSlug)
})
</script>

<style lang="scss" scoped></style>
